import api from './client';

// GET /api/v1/me/access
export const fetchMeAccess = () => api.get('/api/v1/me/access');
